import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project" }
const _hoisted_2 = { class: "column-layout" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_4 = { class: "column-layout" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_6 = { class: "column-layout" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import '../css/ProjectsViewCss.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsView',
  setup(__props) {

const router = useRouter();

function goToSkyTakeOut() {
  router.push("/projects/skyTakeOut");
}

function goToBostonApp() {
  router.push("/projects/bostonApp");
}

function goToPersonalWebsite() {
  router.push("/projects/personalWebsite");
}

const isDesktop = ref(window.innerWidth >= 769);
const buttonSize = ref(isDesktop.value ? 'large' : 'small');

const updateLayout = () => {
  isDesktop.value = window.innerWidth >= 769;
  buttonSize.value = isDesktop.value ? 'large' : 'small';
};

onMounted(() => {
  updateLayout();
  console.log('Initial isDesktop:', isDesktop.value);
  window.addEventListener('resize', updateLayout);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateLayout);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_timeline_item, {
            center: "",
            timestamp: "2024/9",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ProjectsView.personalWebsite')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('ProjectsView.personalWebsiteDate')), 1)
                    ]),
                    _hoisted_3,
                    _createVNode(_component_el_button, {
                      size: buttonSize.value,
                      color: "#626aef",
                      onClick: goToPersonalWebsite
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('ProjectsView.viewDetail')), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            center: "",
            timestamp: "2024/8",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ProjectsView.skyTakeOut')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('ProjectsView.skyTakeOutDate')), 1)
                    ]),
                    _hoisted_5,
                    _createVNode(_component_el_button, {
                      size: buttonSize.value,
                      color: "#626aef",
                      onClick: goToSkyTakeOut
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('ProjectsView.viewDetail')), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            center: "",
            timestamp: "2023/12",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('ProjectsView.bostonApp')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('ProjectsView.bostonAppDate')), 1)
                    ]),
                    _hoisted_7,
                    _createVNode(_component_el_button, {
                      size: buttonSize.value,
                      color: "#626aef",
                      onClick: goToBostonApp
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('ProjectsView.viewDetail')), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})